import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import JobInfo from './JobInfo';
import Worker from '../jobDetails/WorkersTab/Worker';
import { isJobFilled, isJobNotEditable, isJobHasNotStarted } from '../../../helpers/jobs';

export default class JobInfoWrapper extends Component {
  static propTypes = {
    job: PropTypes.object.isRequired,
    JobInfoComponent: PropTypes.func,
    history: PropTypes.object.isRequired,
    isPastJobsList: PropTypes.bool,
    isWorkerDetails: PropTypes.bool,
    isEventView: PropTypes.bool,
    cancelJob: PropTypes.func,
    editJobWorker: PropTypes.func,
    UIShowConfirm: PropTypes.func,
    UIShowAlert: PropTypes.func,
    onQuickViewOpen: PropTypes.func
  };

  state = {
    jobWorkersAreShown: false
  };

  toggleEventJobWorkersSection = e => {
    e.stopPropagation();
    this.setState(prevState => ({ jobWorkersAreShown: !prevState.jobWorkersAreShown }));
  };

  render () {
    const { job, history, cancelJob, isPastJobsList, isWorkerDetails, JobInfoComponent, isEventView, editJobWorker,
      UIShowConfirm, UIShowAlert, onQuickViewOpen } = this.props;
    const RenderJobInfo = JobInfoComponent || JobInfo;
    const { jobWorkersAreShown } = this.state;
    const jobIsNotEditable = isJobNotEditable(job.status, job.is_approved);
    const jobHasNotStarted = isJobHasNotStarted(job.start_date, job.time_zone_id);
    const jobStatusIsFilled = isJobFilled(job.status);

    return (
      <div className={`${isEventView ? 'event-job-data-wrapper' : ''} ${jobWorkersAreShown ? 'expanded' : ''}`}
      >
        <RenderJobInfo
          jobData={job}
          history={history}
          cancelJob={cancelJob}
          isPastJobsList={isPastJobsList}
          isWorkerDetails={isWorkerDetails}
          isEventView={isEventView}
          UIShowConfirm={UIShowConfirm}
          toggleEventJobWorkersSection={this.toggleEventJobWorkersSection}
          jobWorkersAreShown={jobWorkersAreShown}
        />
        { isEventView && job.workers && jobWorkersAreShown && (
          <section className='workers-list-wrapper workers-info'>
            { job.workers.map(worker => {
              return (
                <Worker
                  key={worker.id}
                  worker={worker}
                  jobId={job.id}
                  jobStartDate={moment(job.start_date)}
                  jobEndDate={moment(job.end_date)}
                  time_zone_id={job.time_zone_id}
                  editJobWorker={editJobWorker}
                  UIShowConfirm={UIShowConfirm}
                  UIShowAlert={UIShowAlert}
                  jobIsNotEditable={jobIsNotEditable}
                  jobHasNotStarted={jobHasNotStarted}
                  jobStatusIsFilled={jobStatusIsFilled}
                  onQuickViewOpen={onQuickViewOpen}
                />
              );
            })}
          </section>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobsList/JobInfoWrapper.js